import * as toolbox from '../components/common/toolbox';
import * as types from './action-types';
import firebase from 'firebase/compat/app';

const firestore = firebase.firestore();

/*-----------------------------------------------*/
/*  COMPANY
/*-----------------------------------------------*/

export function subCompany(handle) {

	return dispatch => {

		dispatch({ type: types.COMPANY + '_PENDING' });

		const unsubscribe = firestore.collection(handle).doc('company').onSnapshot((doc) => {
			const company = { ...doc.data() };

			dispatch({ type: types.COMPANY + '_FULFILLED', data: company, unsubscribe });
		});
	} 
}
export function updateCompany(handle, appIds) {

	return (dispatch) => {

		if (appIds.length < 1) {
			toolbox.process_error('At least one app must be enabled', 'App Required!');
			return;
		}

		dispatch({ type: types.COMPANY + '_SAVE_PENDING' });

		// Update handle/company record
		firestore.collection(handle).doc('company').set({ appIds }, { merge: true }).then(() => {
			dispatch({ type: types.COMPANY + '_SAVE_FULFILLED' });
		}).catch((error) => {
			toolbox.process_error(error, 'Asset NOT Saved!');
		});

		// Update _companies record
		firestore.collection('_companies').doc(handle).set({ appIds }, { merge: true }).then(() => {
			dispatch({ type: types.COMPANY + '_SAVE_FULFILLED' });
		}).catch((error) => {
			toolbox.process_error(error, 'Asset NOT Saved!');
		});
	}
}